module.exports = __webpack_public_path__ + "img/0fa24dc.jpg";